(() => {
  // app/scripts/common/function/cart.js
  window.cartForm = class extends HTMLElement {
    constructor() {
      super();
      this.sections = [
        {
          key: "section",
          section: "cart-section"
        },
        {
          key: "noti",
          section: "cart-noti"
        },
        {
          key: "count",
          section: "cart-live-region-text"
        }
      ];
    }
    sectionList(section) {
      if (section) {
        const callSection = section.split(",");
        return this.sections.filter((i) => callSection.includes(i.key)).map((i) => i.section).join(",");
      }
      return this.sections.map((i) => i.section).join(",");
    }
    getHeader(formData) {
      if (!(formData instanceof FormData)) {
        return { "Content-Type": "application/json" };
      } else
        return { "X-Requested-With": "XMLHttpRequest" };
    }
    async postCart(type, data, callback = null, loadingState = true) {
      type != "update" && window.addEventListener("cart:update", this.update.bind(this), { once: true });
      if (type == "add" && loadingState) {
        this.loadingState = true;
      }
      let status = true;
      let response = await fetch(`${theme.routes.cartUrl}/${type}.js`, {
        method: "POST",
        headers: this.getHeader(data),
        body: data
      });
      response = await response.json();
      if (type == "update") {
        return;
      }
      if (type == "add" && loadingState)
        this.loadingState = false;
      if (response.status) {
        console.error(response);
        this.notify(response.description || response.message);
        status = false;
        response.sections = await this.refresh();
      }
      const { sections } = response;
      window.dispatchEvent(
        new CustomEvent("cart:update", {
          detail: {
            sections,
            status,
            cart: response
          }
        })
      );
      callback != null && callback(response);
    }
    async refresh() {
      let response = await fetch(`${location.pathname}?sections=${this.sectionList()}`);
      response = await response.json();
      return response;
    }
    update(evt) {
      const {
        detail: { sections }
      } = evt;
      for (const [section, html] of Object.entries(sections)) {
        const key = this.sections.find((i) => i.section == section)?.key || section;
        switch (key) {
          case "count":
            this.updateCartCount = html.split("<!-- split -->")[1];
            break;
          default:
            let div = document.createElement("div");
            div.innerHTML = html;
            div.querySelectorAll(".jsCartUpdate")?.forEach((newItem) => {
              const currentItem = document.querySelector(`[class="${newItem.className}"]`);
              if (currentItem) {
                currentItem.innerHTML = newItem.innerHTML;
              }
            });
        }
      }
    }
    async notify(msg) {
      const searchParams = new URLSearchParams();
      searchParams.set("q", msg);
      searchParams.set("section_id", "cart-noti");
      let response = await fetch(`${theme.routes.searchUrl}?${searchParams.toString()}`);
      response = await response.text();
      let div = document.createElement("div");
      div.innerHTML = response;
      Array.from(div.querySelector(".shopify-section").children).forEach((el) => {
        document.body.insertAdjacentElement("beforeend", el);
      });
    }
    set loadingState(bool) {
      const buttons = Array.from(this.form.elements).filter((button) => button.type === "submit");
      if (bool) {
        buttons.forEach((button) => {
          button.setAttribute("aria-busy", true);
          button.classList.add("disabled");
          button.HTMLTemp = button.innerHTML;
          button.innerHTML = document.querySelector("#svg_loading").innerHTML;
        });
      } else {
        buttons.forEach((button) => {
          button.removeAttribute("aria-busy");
          button.classList.remove("disabled");
          button.innerHTML = button.HTMLTemp;
          button.HTMLTemp = null;
        });
      }
    }
    set updateCartCount(value) {
      document.querySelectorAll(".jsCartCount")?.forEach((item) => item.setAttribute("data-count", value));
    }
  };

  // app/scripts/common/component/productCartDrawer.js
  var productCartDrawerForm = class extends cartForm {
    constructor() {
      super();
      if (theme.settings.cartStyle == "page")
        return;
      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.onSubmit.bind(this));
    }
    onSubmit(event) {
      event.preventDefault();
      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }
      const formData = new FormData(this.form);
      formData.append("sections", this.sectionList());
      formData.append("sections_url", this.dataset.url || location.pathname);
      this.postCart("add", formData, () => {
      });
    }
  };
  !customElements.get("product-cart-drawer-form") && customElements.define("product-cart-drawer-form", productCartDrawerForm);

  // app/scripts/common/function/currencies.js
  var multiCurrency = {};
  multiCurrency.moneyFormats = {
    USD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} USD"
    },
    EUR: {
      money_format: "&euro;{{amount}}",
      money_with_currency_format: "&euro;{{amount}} EUR"
    },
    GBP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} GBP"
    },
    CAD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} CAD"
    },
    ALL: {
      money_format: "Lek {{amount}}",
      money_with_currency_format: "Lek {{amount}} ALL"
    },
    DZD: {
      money_format: "DA {{amount}}",
      money_with_currency_format: "DA {{amount}} DZD"
    },
    AOA: {
      money_format: "Kz{{amount}}",
      money_with_currency_format: "Kz{{amount}} AOA"
    },
    ARS: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} ARS"
    },
    AMD: {
      money_format: "{{amount}} AMD",
      money_with_currency_format: "{{amount}} AMD"
    },
    AWG: {
      money_format: "Afl{{amount}}",
      money_with_currency_format: "Afl{{amount}} AWG"
    },
    AUD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} AUD"
    },
    BBD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} Bds"
    },
    AZN: {
      money_format: "m.{{amount}}",
      money_with_currency_format: "m.{{amount}} AZN"
    },
    BDT: {
      money_format: "Tk {{amount}}",
      money_with_currency_format: "Tk {{amount}} BDT"
    },
    BSD: {
      money_format: "BS${{amount}}",
      money_with_currency_format: "BS${{amount}} BSD"
    },
    BHD: {
      money_format: "{{amount}}0 BD",
      money_with_currency_format: "{{amount}}0 BHD"
    },
    BYR: {
      money_format: "Br {{amount}}",
      money_with_currency_format: "Br {{amount}} BYR"
    },
    BZD: {
      money_format: "BZ${{amount}}",
      money_with_currency_format: "BZ${{amount}} BZD"
    },
    BTN: {
      money_format: "Nu {{amount}}",
      money_with_currency_format: "Nu {{amount}} BTN"
    },
    BAM: {
      money_format: "KM {{amount_with_comma_separator}}",
      money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
    },
    BRL: {
      money_format: "R$ {{amount_with_comma_separator}}",
      money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
    },
    BOB: {
      money_format: "Bs{{amount_with_comma_separator}}",
      money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
    },
    BWP: {
      money_format: "P{{amount}}",
      money_with_currency_format: "P{{amount}} BWP"
    },
    BND: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} BND"
    },
    BGN: {
      money_format: "{{amount}} \u043B\u0432",
      money_with_currency_format: "{{amount}} \u043B\u0432 BGN"
    },
    MMK: {
      money_format: "K{{amount}}",
      money_with_currency_format: "K{{amount}} MMK"
    },
    KHR: {
      money_format: "KHR{{amount}}",
      money_with_currency_format: "KHR{{amount}}"
    },
    KYD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} KYD"
    },
    XAF: {
      money_format: "FCFA{{amount}}",
      money_with_currency_format: "FCFA{{amount}} XAF"
    },
    CLP: {
      money_format: "${{amount_no_decimals}}",
      money_with_currency_format: "${{amount_no_decimals}} CLP"
    },
    CNY: {
      money_format: "&#165;{{amount}}",
      money_with_currency_format: "&#165;{{amount}} CNY"
    },
    COP: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} COP"
    },
    CRC: {
      money_format: "&#8353; {{amount_with_comma_separator}}",
      money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
    },
    HRK: {
      money_format: "{{amount_with_comma_separator}} kn",
      money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
    },
    CZK: {
      money_format: "{{amount_with_comma_separator}} K&#269;",
      money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
    },
    DKK: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "kr.{{amount_with_comma_separator}}"
    },
    DOP: {
      money_format: "RD$ {{amount}}",
      money_with_currency_format: "RD$ {{amount}}"
    },
    XCD: {
      money_format: "${{amount}}",
      money_with_currency_format: "EC${{amount}}"
    },
    EGP: {
      money_format: "LE {{amount}}",
      money_with_currency_format: "LE {{amount}} EGP"
    },
    ETB: {
      money_format: "Br{{amount}}",
      money_with_currency_format: "Br{{amount}} ETB"
    },
    XPF: {
      money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
    },
    FJD: {
      money_format: "${{amount}}",
      money_with_currency_format: "FJ${{amount}}"
    },
    GMD: {
      money_format: "D {{amount}}",
      money_with_currency_format: "D {{amount}} GMD"
    },
    GHS: {
      money_format: "GH&#8373;{{amount}}",
      money_with_currency_format: "GH&#8373;{{amount}}"
    },
    GTQ: {
      money_format: "Q{{amount}}",
      money_with_currency_format: "{{amount}} GTQ"
    },
    GYD: {
      money_format: "G${{amount}}",
      money_with_currency_format: "${{amount}} GYD"
    },
    GEL: {
      money_format: "{{amount}} GEL",
      money_with_currency_format: "{{amount}} GEL"
    },
    HNL: {
      money_format: "L {{amount}}",
      money_with_currency_format: "L {{amount}} HNL"
    },
    HKD: {
      money_format: "${{amount}}",
      money_with_currency_format: "HK${{amount}}"
    },
    HUF: {
      money_format: "{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
    },
    ISK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr ISK"
    },
    INR: {
      money_format: "Rs. {{amount}}",
      money_with_currency_format: "Rs. {{amount}}"
    },
    IDR: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "Rp {{amount_with_comma_separator}}"
    },
    ILS: {
      money_format: "{{amount}} NIS",
      money_with_currency_format: "{{amount}} NIS"
    },
    JMD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} JMD"
    },
    JPY: {
      money_format: "&#165;{{amount_no_decimals}}",
      money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
    },
    JEP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} JEP"
    },
    JOD: {
      money_format: "{{amount}}0 JD",
      money_with_currency_format: "{{amount}}0 JOD"
    },
    KZT: {
      money_format: "{{amount}} KZT",
      money_with_currency_format: "{{amount}} KZT"
    },
    KES: {
      money_format: "KSh{{amount}}",
      money_with_currency_format: "KSh{{amount}}"
    },
    KWD: {
      money_format: "{{amount}}0 KD",
      money_with_currency_format: "{{amount}}0 KWD"
    },
    KGS: {
      money_format: "\u043B\u0432{{amount}}",
      money_with_currency_format: "\u043B\u0432{{amount}}"
    },
    LVL: {
      money_format: "Ls {{amount}}",
      money_with_currency_format: "Ls {{amount}} LVL"
    },
    LBP: {
      money_format: "L&pound;{{amount}}",
      money_with_currency_format: "L&pound;{{amount}} LBP"
    },
    LTL: {
      money_format: "{{amount}} Lt",
      money_with_currency_format: "{{amount}} Lt"
    },
    MGA: {
      money_format: "Ar {{amount}}",
      money_with_currency_format: "Ar {{amount}} MGA"
    },
    MKD: {
      money_format: "\u0434\u0435\u043D {{amount}}",
      money_with_currency_format: "\u0434\u0435\u043D {{amount}} MKD"
    },
    MOP: {
      money_format: "MOP${{amount}}",
      money_with_currency_format: "MOP${{amount}}"
    },
    MVR: {
      money_format: "Rf{{amount}}",
      money_with_currency_format: "Rf{{amount}} MRf"
    },
    MXN: {
      money_format: "$ {{amount}}",
      money_with_currency_format: "$ {{amount}} MXN"
    },
    MYR: {
      money_format: "RM{{amount}} MYR",
      money_with_currency_format: "RM{{amount}} MYR"
    },
    MUR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} MUR"
    },
    MDL: {
      money_format: "{{amount}} MDL",
      money_with_currency_format: "{{amount}} MDL"
    },
    MAD: {
      money_format: "{{amount}} dh",
      money_with_currency_format: "Dh {{amount}} MAD"
    },
    MNT: {
      money_format: "{{amount_no_decimals}} &#8366",
      money_with_currency_format: "{{amount_no_decimals}} MNT"
    },
    MZN: {
      money_format: "{{amount}} Mt",
      money_with_currency_format: "Mt {{amount}} MZN"
    },
    NAD: {
      money_format: "N${{amount}}",
      money_with_currency_format: "N${{amount}} NAD"
    },
    NPR: {
      money_format: "Rs{{amount}}",
      money_with_currency_format: "Rs{{amount}} NPR"
    },
    ANG: {
      money_format: "&fnof;{{amount}}",
      money_with_currency_format: "{{amount}} NA&fnof;"
    },
    NZD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} NZD"
    },
    NIO: {
      money_format: "C${{amount}}",
      money_with_currency_format: "C${{amount}} NIO"
    },
    NGN: {
      money_format: "&#8358;{{amount}}",
      money_with_currency_format: "&#8358;{{amount}} NGN"
    },
    NOK: {
      money_format: "kr {{amount_with_comma_separator}}",
      money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
    },
    OMR: {
      money_format: "{{amount_with_comma_separator}} OMR",
      money_with_currency_format: "{{amount_with_comma_separator}} OMR"
    },
    PKR: {
      money_format: "Rs.{{amount}}",
      money_with_currency_format: "Rs.{{amount}} PKR"
    },
    PGK: {
      money_format: "K {{amount}}",
      money_with_currency_format: "K {{amount}} PGK"
    },
    PYG: {
      money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    },
    PEN: {
      money_format: "S/. {{amount}}",
      money_with_currency_format: "S/. {{amount}} PEN"
    },
    PHP: {
      money_format: "&#8369;{{amount}}",
      money_with_currency_format: "&#8369;{{amount}} PHP"
    },
    PLN: {
      money_format: "{{amount_with_comma_separator}} zl",
      money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
    },
    QAR: {
      money_format: "QAR {{amount_with_comma_separator}}",
      money_with_currency_format: "QAR {{amount_with_comma_separator}}"
    },
    RON: {
      money_format: "{{amount_with_comma_separator}} lei",
      money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
    },
    RUB: {
      money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
      money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    },
    RWF: {
      money_format: "{{amount_no_decimals}} RF",
      money_with_currency_format: "{{amount_no_decimals}} RWF"
    },
    WST: {
      money_format: "WS$ {{amount}}",
      money_with_currency_format: "WS$ {{amount}} WST"
    },
    SAR: {
      money_format: "{{amount}} SR",
      money_with_currency_format: "{{amount}} SAR"
    },
    STD: {
      money_format: "Db {{amount}}",
      money_with_currency_format: "Db {{amount}} STD"
    },
    RSD: {
      money_format: "{{amount}} RSD",
      money_with_currency_format: "{{amount}} RSD"
    },
    SCR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} SCR"
    },
    SGD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} SGD"
    },
    SYP: {
      money_format: "S&pound;{{amount}}",
      money_with_currency_format: "S&pound;{{amount}} SYP"
    },
    ZAR: {
      money_format: "R {{amount}}",
      money_with_currency_format: "R {{amount}} ZAR"
    },
    KRW: {
      money_format: "&#8361;{{amount_no_decimals}}",
      money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
    },
    LKR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} LKR"
    },
    SEK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr SEK"
    },
    CHF: {
      money_format: "SFr. {{amount}}",
      money_with_currency_format: "SFr. {{amount}} CHF"
    },
    TWD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TWD"
    },
    THB: {
      money_format: "{{amount}} &#xe3f;",
      money_with_currency_format: "{{amount}} &#xe3f; THB"
    },
    TZS: {
      money_format: "{{amount}} TZS",
      money_with_currency_format: "{{amount}} TZS"
    },
    TTD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TTD"
    },
    TND: {
      money_format: "{{amount}}",
      money_with_currency_format: "{{amount}} DT"
    },
    TRY: {
      money_format: "{{amount}}TL",
      money_with_currency_format: "{{amount}}TL"
    },
    UGX: {
      money_format: "Ush {{amount_no_decimals}}",
      money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
    },
    UAH: {
      money_format: "\u20B4{{amount}}",
      money_with_currency_format: "\u20B4{{amount}} UAH"
    },
    AED: {
      money_format: "Dhs. {{amount}}",
      money_with_currency_format: "Dhs. {{amount}} AED"
    },
    UYU: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} UYU"
    },
    VUV: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}}VT"
    },
    VEF: {
      money_format: "Bs. {{amount_with_comma_separator}}",
      money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
    },
    VND: {
      money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
    },
    XBT: {
      money_format: "{{amount_no_decimals}} BTC",
      money_with_currency_format: "{{amount_no_decimals}} BTC"
    },
    XOF: {
      money_format: "CFA{{amount}}",
      money_with_currency_format: "CFA{{amount}} XOF"
    },
    ZMW: {
      money_format: "K{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
    }
  };
  multiCurrency.formatMoney = function(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };
  var currencies_default = multiCurrency;

  // app/scripts/common/component/priceComponent.js
  var moneyElement = class extends HTMLElement {
    constructor() {
      super();
      this.value = +this.dataset.value;
      this.content = this.lastElementChild || this;
    }
    get() {
      return this.value;
    }
    set(value = null) {
      this.value = value;
      if (value == null) {
        this.content.innerHTML = "";
        return;
      }
      let currencyFormat = this.dataset.format || theme.settings.currencyFormat || "money_format";
      let f = currencies_default.moneyFormats[theme.settings.currency][currencyFormat] || "{{amount}}";
      this.content.innerHTML = currencies_default.formatMoney(value, f);
    }
  };
  !customElements.get("price-component") && customElements.define("price-component", moneyElement);

  // app/scripts/common/component/quantity.js
  if (!customElements.get("quantity-input")) {
    class QuantityInput extends HTMLElement {
      constructor() {
        super();
        this.changeEvent = new Event("change", { bubbles: true });
        this.input = this.querySelector("input");
        if (this.input) {
          this.querySelectorAll("button")?.forEach((button) => {
            button.addEventListener("click", this.onButtonClick.bind(this));
          });
        } else {
          this.querySelector("select")?.addEventListener("change", (e) => {
            this.dispatchEvent(this.changeEvent);
          });
        }
      }
      onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value)
          this.input.dispatchEvent(this.changeEvent);
      }
    }
    customElements.define("quantity-input", QuantityInput);
  }

  // app/scripts/common/component/cartRemove.js
  var customElementsName = "cart-remove-button";
  !window.customElements.get(customElementsName) && window.customElements.define(customElementsName, class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", (e) => {
        const { target } = e;
        if (!target.closest("a"))
          return;
        const link = target.closest("a");
        e.preventDefault();
        this.closest("cart-component").dispatchEvent(new CustomEvent("change", {
          bubbles: true,
          detail: {
            customElement: link
          }
        }));
      });
    }
  });

  // app/scripts/common/component/cartRecommendations.js
  var cartRecommendations = class extends HTMLElement {
    constructor() {
      super();
      if (this.isLoaded)
        return;
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting)
          return;
        observer.unobserve(this);
        this.onLoad();
      };
      const options = {
        rootMargin: "200px 0px 200px 0px"
      };
      new IntersectionObserver(handleIntersection.bind(this), options).observe(this);
    }
    onLoad() {
      this.dataset.listId ? this.fetchArray() : this.fetch();
    }
    fetch() {
      fetch(this.dataset.url).then((response) => response.text()).then((html) => {
        this.loaded(html);
      }).catch((e) => {
        console.error(e);
      });
    }
    fetchArray() {
      const arrayPromise = [];
      const listId = this.dataset.listId.split(",");
      listId.forEach((id) => {
        arrayPromise.push(
          new Promise((resolved) => {
            const url = this.dataset.url.replace("PRODUCTID", id.trim());
            fetch(url).then((response) => response.text()).then((html) => {
              resolved(html);
            });
          })
        );
      });
      Promise.all(arrayPromise).then((result) => {
        this.loaded(result.join(""));
      });
    }
    loaded(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      const itemList = div.querySelectorAll(".swiper-slide");
      if (!itemList.length) {
        this.classList.add("none");
        return;
      } else if (itemList.length == 1 && this.classList.contains("block-recommendation")) {
        this.classList.add("full-width");
      }
      const wrapper = this.querySelector(".jsSlider");
      [...itemList].slice(0, parseInt(this.dataset.limit)).forEach((item) => {
        wrapper.insertAdjacentElement("afterbegin", item);
      });
      this.classList.add("recommend-initialized");
      this.querySelector(".js-container")?.classList.remove("none");
      this.querySelector("swiper-component")?.load();
    }
  };
  customElements.define("cart-recommendations", cartRecommendations);

  // app/scripts/cart-component.js
  !customElements.get("cart-component") && customElements.define(
    "cart-component",
    class extends cartForm {
      constructor() {
        super();
        const debounce = this.debounceTime((e) => this.change(e), 300);
        this.addEventListener("change", debounce.bind(this));
        window.addEventListener("cart:update", this.onUpdate.bind(this));
      }
      debounceTime(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
      change(event) {
        let target = event.target;
        let quantity = 0;
        if (event.detail) {
          target = event.detail.customElement;
        } else {
          quantity = +target.value;
        }
        let { line, sections: section, sections_url } = target.dataset;
        if (!line)
          return;
        this.sections.find((i) => i.key == "section").section = section;
        let sections = this.sections.map((i) => i.section);
        sections.push(section);
        sections = Array.from(new Set(sections));
        const body = {
          line,
          quantity,
          sections,
          sections_url
        };
        target.replaceWith(document.querySelector("#svg_loading > svg").cloneNode(true));
        this.classList.add("event-none");
        this.postCart("change", JSON.stringify(body), (resp) => {
          this.classList.remove("event-none");
        });
      }
      onUpdate(evt) {
        const {
          detail: { sections, status, cart }
        } = evt;
        if (!status)
          return;
        if (theme.routes.pageType == "cart") {
          !cart.item_count && location.reload();
        } else if (theme.settings.cartStyle == "drawer_desktop" && !window.matchMedia("(min-width: 750px)").matches) {
          window.location.href = theme.routes.cartUrl;
        } else {
          this.open();
        }
      }
      open() {
        this.closest("popup-component")?.open();
      }
      close() {
        this.closest("popup-component")?.close();
      }
    }
  );
})();
